import { ROUTES } from "@/shared/config/routes";
import { useClientRedirect } from "@/shared/lib/router/redirect";

// O hub dos apps virou o Centro de entregas; o link antigo continua funcionando.
export default function AdminAppHubRedirect() {
  useClientRedirect(ROUTES.deliveryCenter);
  return null;
}

